import { useState } from "react";
import styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateDataset } from "../../../../../redux/dataset/datasetSlice";
import { useRef } from "react";
import swal from "sweetalert";

const SingleSpeaker = ({ speaker, isEditing }) => {
  const [speakerEditable, setSpeakerEditable] = useState(false);
  const dispatch = useDispatch();
  const speakerField = useRef(null);
  const data = useSelector((state) => state.datasetSlice.dataset);

  const handleSpeakerUpdate = (updatedSpeakerName, originalName) => {
    const newSpeakerArray = data.speakers.map((speaker) => {
      if (speaker === originalName) {
        return updatedSpeakerName;
      }
      return speaker;
    });
    dispatch(updateDataset({ speakers: newSpeakerArray }));

    const newSegmentsArray = data.transcript.segments.map((segment) => {
      if (segment.speaker === originalName) {
        return { ...segment, speaker: updatedSpeakerName };
      }
      return segment;
    });
    dispatch(
      updateDataset({
        transcript: { ...data.transcript, segments: newSegmentsArray },
      })
    );
  };

  const handleSpeakerDelete = (speakerToDelete) => {
    const noOfSegments = data.transcript.segments.filter(
      (segment) => segment.speaker === speakerToDelete
    ).length;
    const newSpeakerArray = data.speakers.filter(
      (speaker) => speaker !== speakerToDelete
    );
    const newSegmentsArray = data.transcript.segments.map((segment) => {
      if (segment.speaker === speakerToDelete) {
        return { ...segment, speaker: "" };
      }
      return segment;
    });
    if (noOfSegments > 0) {
      swal({
        title: "Are you sure?",
        text: `This speaker has ${noOfSegments} segments. Are you sure you want to delete this speaker? You will have to assign a new speaker to segments manually.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          dispatch(
            updateDataset({
              speakers: newSpeakerArray,
              transcript: { ...data.transcript, segments: newSegmentsArray },
            })
          );
        }
      });
    } else {
      swal(
        "Speaker deleted!",
        "Speaker has been deleted successfully.",
        "success"
      );
      dispatch(updateDataset({ speakers: newSpeakerArray }));
    }
  };

  const toggleSpeakerEditable = () => {
    if (speakerEditable) {
      const updatedSpeakerName = speakerField.current.value;
      handleSpeakerUpdate(updatedSpeakerName, speaker);
    }
    setSpeakerEditable(!speakerEditable);
  };
  return (
    <div className={styles.singleSpeakerWrapper}>
      <div className={styles.speakerInfo}>
        <img className={styles.image} src="/icons/user.svg" alt="speaker" />
        {speakerEditable ? (
          <input
            className={styles.speakerNameInput}
            ref={speakerField}
            defaultValue={speaker}
          />
        ) : (
          <span className={styles.speakerName} ref={speakerField}>
            {speaker}
          </span>
        )}
      </div>

      {isEditing && (
        <>
          <div className={styles.speakerActions}>
            <img
              className={styles.edit}
              src={
                speakerEditable
                  ? "/icons/check-mark.svg"
                  : "/icons/blue-edit.svg"
              }
              alt="edit"
              onClick={toggleSpeakerEditable}
            />
            {data.speakers.length > 1 && (
              <img
                className={styles.delete}
                src="/icons/remove.svg"
                alt="delete"
                onClick={() => handleSpeakerDelete(speaker)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SingleSpeaker;
